import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { FormattedMessage, useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';

import StarRating from '../../StarRating';
import Avatar from '../../Avatar';
import Loader from '../../Loader';

import messages from '../../../locale/messages';

import bt from '../../../components/commonStyle.css';
import s from './Reviews.css';
const Reviews = (props) => {

  const { formatMessage } = useIntl();
  const siteName = useSelector(state => state.siteSettings.data.siteName);

  const loadMore = (ownerType) => {
    const { data: { moreListReviews, fetchMore }, listId } = props;
    fetchMore({
      //query: UserReviewsQuery,
      variables: {
        listId,
        offset: moreListReviews.length,
        loadCount: 5,
      },
      updateQuery: (previousResult, { fetchMoreResult }) => {
        if (!fetchMoreResult) { return previousResult; }

        return {
          moreListReviews: [...previousResult.moreListReviews, ...fetchMoreResult.moreListReviews],
        };
      },
    });
  }

  const { data: { loading, moreListReviews } } = props;
  const { reviewsCount, reviewsStarRating } = props;
  let starRatingValue = 0, showLoadMore = true;
  if (reviewsCount > 0 && reviewsStarRating > 0) {
    starRatingValue = Math.round((reviewsStarRating / reviewsCount) * 10) / 10;
  }

  if (moreListReviews && reviewsCount === moreListReviews.length) {
    showLoadMore = false;
  }

  if (loading) {
    return <Loader type={"text"} />
  }

  if (reviewsCount === 0) {
    return (
      <div>
        <div className={cx(s.pageContent)}>
          <div className={cx(s.spaceTop4)}>
            <h2 className={cx(s.sectionTitleText)}><FormattedMessage {...messages.noReviewTitle} /></h2>
            <p className={s.textMuted}><FormattedMessage {...messages.noReviewInfo} /></p>
          </div>
        </div>
        <div className={s.listingLine}></div>
      </div>
    );
  }

  return (
    <div>
      <div className={cx(s.pageContent, s.borderMarginTop)}>
        <h2 className={cx(s.sectionTitleText, 'reviewStarAlign')}>
          <StarRating value={starRatingValue} className='bigStarRatingAdjust' />
          <span>{reviewsCount} {reviewsCount > 1 ? formatMessage(messages.reviews) : formatMessage(messages.review)}</span>
        </h2>
        {
          !loading && moreListReviews && moreListReviews.map((item, index) => {
            let date = moment(parseInt(item.createdAt)).format('MMMM YYYY');
            return (
              <div className={cx(s.horizontalLineThrough)} key={index}>
                {
                  !item.isAdmin && item.authorData && <div className={s.reviewContainer}>
                    <div className={cx(s.alignMiddle)}>
                      <div className={cx(s.pullLeft, s.mediaContainer, s.textCenter)} >
                        <Avatar
                          source={item.authorData.picture}
                          height={48}
                          width={48}
                          title={item.authorData.firstName}
                          className={s.profileAvatar}
                          withLink
                          linkClassName={cx(s.profileAvatarLink, s.noBackground)}
                          profileId={item.authorData.profileId}
                          isFromMigration={item.authorData?.isMigrated}
                        />
                      </div>
                    </div>
                    <div className={s.alignMiddle}>
                      <div className={s.infoAlign}>
                        <div className={s.textBold}>{item.authorData.firstName}</div>
                        <div className={s.reviewFlex}>
                          <StarRating value={item.rating} className='smallStarRatingAdjust' />
                          <div>{item.rating}</div>
                          <div className={s.dateReviewCss}>{date}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                }
                {
                  item.isAdmin && <div className={s.reviewContainer}>
                    <div className={cx(s.alignMiddle)}>
                      <div className={cx(s.pullLeft, s.mediaContainer, s.textCenter)} >
                        <Avatar
                          source={'../../../../adminAvatar.png'}
                          height={54}
                          width={54}
                          title={formatMessage(messages.verifiedBy) + ' ' + siteName}
                          className={cx(s.profileAvatar, s.noBackground)}
                          linkClassName={s.profileAvatarLink}
                          staticImage
                        />
                      </div>
                    </div>
                    <div className={s.alignMiddle}>
                      <div className={cx(s.infoAlign, 'infoAlignRTL')}>
                        <span className={s.textBold}>{formatMessage(messages.verifiedBy) + ' ' + siteName}</span>
                        <div className={s.reviewFlex}>
                          <StarRating value={item.rating} className='smallStarRatingAdjust' />
                          <div>{item.rating}</div>
                          <div className={s.dateReviewCss}>{date}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                }
                <div className='clearBoth'> </div>
                <div className={s.commentSection}>
                  {
                    item.reviewContent && (item.reviewContent.trim()).split("\n").map(function (content, index) {
                      return (
                        <span key={index}>
                          {content}
                          <br />
                        </span>
                      )
                    })
                  }
                </div>
              </div>
            )
          })
        }
        {
          showLoadMore && <div className={cx(s.space2)}>
            <a className={cx(bt.btnPrimaryBorder, s.borderRadius)} onClick={() => loadMore()}>
              <FormattedMessage {...messages.showAllReviews} />
            </a>
          </div>
        }

      </div>
      <div className={s.listingLine}></div>
    </div>
  );
}

Reviews.propTypes = {
  formatMessage: PropTypes.any,
  listId: PropTypes.number.isRequired,
  reviewsCount: PropTypes.number.isRequired,
  reviewsStarRating: PropTypes.number.isRequired,
  data: PropTypes.shape({
    loading: PropTypes.bool,
    moreListReviews: PropTypes.arrayOf(PropTypes.shape({
      reservationId: PropTypes.number.isRequired,
      authorData: PropTypes.shape({
        firstName: PropTypes.string.isRequired,
        lastName: PropTypes.string.isRequired,
        picture: PropTypes.string,
        profileId: PropTypes.number.isRequired,
      }),
      reviewContent: PropTypes.string.isRequired,
      rating: PropTypes.number,
      parentId: PropTypes.number.isRequired,
      createdAt: PropTypes.string.isRequired,
    })),
  })
};

Reviews.defaultProps = {
  loading: true
};

export default withStyles(s, bt)(Reviews);
